const API_URL = "https://accademia-backend.vercel.app"

export default API_URL;